<template>
  <div class="home-container">
    <h2 class="ttl-te">我们的发展</h2>
    <div class="center-block">
      <el-timeline style="max-width: 600px">
        <el-timeline-item timestamp="2024/2/12" placement="top">
          <el-card>
            <h3>重构我们的网站</h3>
            <p>我决定用vue重构并完善藏族服饰展示平台，做成一个多元化的平台，不局限于青海藏族服饰，而是将青海地区多个少数民族服饰都进行收集和保护 2024/2/12 20:46</p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2023/5/3" placement="top">
          <el-card>
            <h3>基于三维建模技术的藏族服饰展示平台制作完成并上线</h3>
            <p>经过长达一年的摸索学习，利用去一线进行田野调查收集到了大量藏族传统服饰的图片和文本数据，逐步完善，做出了我们第一个服饰保护平台。 2023/5/3 20:46</p>
          </el-card>
        </el-timeline-item>
        <el-timeline-item timestamp="2022/4/2" placement="top">
          <el-card>
            <h3>青海藏族服饰保护项目立项</h3>
            <p>我们的项目正式立项 2022/4/2 20:46</p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
    </div>
  <h2 class="ttl">我们的愿景</h2>
  <p class="p">  我们致力于弘扬和传承青海民族服饰文化，同时推动其在现代社会的创新与发展：</p>
  <p class="p">1.文化传承：我们希望通过我们的网站，让更多人了解并尊重各民族的服饰文化。我们希望这些独特的服饰传统能够得以传承，让后人也能欣赏到这些丰富多彩的文化遗产。</p>
  <p class="p">2.知识普及：我们致力于提供详细、准确的民族服饰知识，包括其历史背景、制作工艺、符号意义等。我们希望通过教育普及，提高公众对民族服饰的认知和欣赏水平。</p>
  <p class="p">3.创新发展：我们鼓励在尊重传统的基础上，对民族服饰进行创新设计。我们希望通过这种方式，让民族服饰在现代社会中焕发新的活力，满足更多人的审美需求。</p>
  <p class="p">4.全球推广：我们希望能够将民族服饰文化推向全球，让更多人看到并爱上这些独特的服饰。我们希望通过我们的努力，让民族服饰在全球范围内得到更广泛的认可和欣赏。</p>
  <p class="p">总的来说，我们的理想是通过民族服饰保护和宣传网站，为保护和传承民族服饰文化做出贡献，同时推动其在现代社会中的创新与发展。我们希望通过我们的努力，让民族服饰文化在全球范围内焕发出新的生机和活力。我们希望通过建立藏族服饰模型库，实现数据信息永久保存，让藏族服饰文化在更大的范围内进行传承与发扬！</p>
    <template>
      <el-card style="max-width: 100%;color: #858383" >
        <p>邮箱：1806186849@qq.com</p>
        <p>电话：1806186849</p>
        <p style="text-align: center; ">@2022-2024 版权所有</p>
      </el-card>
    </template>


  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      imgs:[],
    }
  },
  created() {
    this.load()
  },
  methods:{
    load(){
      this.request.get('/banner').then(res=>{
        this.imgs = res.data.map(item=>item.img)
      })
    }
  },
};
</script>

<style lang="scss">
.home-container {
  padding-top: 0;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  width: 50%; /* 或者具体的像素值 */
}
.p {
  color: #666666;
  font-family: Serif;
  font-size: 17px;
  margin-bottom: 20px;
  padding-left: 15%;  /* 设置左内边距为父元素宽度的10% */
  padding-right: 15%; /* 设置右内边距为父元素宽度的10% */
}

.ttl-te {
  font-family: Serif;
  font-size: 25px;
  padding-left: 15%;
  font-weight: bold;
  color: #000000;
}
.ttl {
  font-family: serif;
  font-size: 25px;
  padding-left: 15%;

  color: #000000;
}
</style>